import i18n, { Ti18nKeys } from "../../../constants/i18n";
import { EApprovalItemStatus } from "../../../constants/enum/approval-item-status";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { TEt3Theme } from "../../../core/et3-theme";
import ApprovalChip from "./ApprovalChip";
import {
  APPROVAL_SOFT_APPROVED,
  APPROVAL_SOFT_DELETED,
  APPROVAL_SOFT_PENDING,
  APPROVAL_SOFT_REJECTED
} from "./approval-data-constants";

const getStatusLabelKey = (status: EApprovalItemStatus): Ti18nKeys => {
  switch (status) {
    case EApprovalItemStatus.APPROVED:
      return "APPROVED";
    case EApprovalItemStatus.REJECTED:
      return "REJECTED";
    case EApprovalItemStatus.DELETED:
      return "DELETED";
    default:
      return "PENDING";
  }
};

export const getStatusToneColor = (
  status: EApprovalItemStatus,
  theme: TEt3Theme
) => {
  const { colors } = theme;
  switch (status) {
    case EApprovalItemStatus.APPROVED:
      return colors.all.seaGreen;
    case EApprovalItemStatus.REJECTED:
      return colors.all.red;
    case EApprovalItemStatus.DELETED:
      return colors.all.gray;
    default:
      return colors.all.davysGrey;
  }
};

export const getStatusBackgroundColor = (status: EApprovalItemStatus) => {
  switch (status) {
    case EApprovalItemStatus.APPROVED:
      return APPROVAL_SOFT_APPROVED;
    case EApprovalItemStatus.REJECTED:
      return APPROVAL_SOFT_REJECTED;
    case EApprovalItemStatus.DELETED:
      return APPROVAL_SOFT_DELETED;
    default:
      return APPROVAL_SOFT_PENDING;
  }
};

const ApprovalStatusChip = withLiteObserverAndTheme<{
  status: EApprovalItemStatus;
}>((props) => {
  const { status, theme } = props;

  return (
    <ApprovalChip
      label={i18n.get(getStatusLabelKey(status))}
      toneColor={getStatusToneColor(status, theme)}
      backgroundColor={getStatusBackgroundColor(status)}
    />
  );
});
export default ApprovalStatusChip;
